import React from "react"
import { ScheduleItinerary } from "../Schedule"
import {PenguinPerksButton} from "../BookNow"

const Fares = props => {

  return (
    <>
      <div className="schedule-page-schedules-container">
        <div className="schedule-fares-container">{props.children}</div>
        <p className="schedules-page-schedules-disclaimer">
          *Does not include taxes and fees
        </p>
        <PenguinPerksButton />
      </div>
    </>
  )
}

const FaresTable = ({ fares }) => {
  return (
    <div className="schedule-table-container">
      <table className="schedule-table">
        <tbody>
          <FaresHeader titles={fares.titles} />
          <ScheduleItinerary itinerary={fares.data} />
        </tbody>
      </table>
    </div>
  )
}

const FaresHeader = ({ titles }) => {
  return (
    <>
      <tr>
        {titles.map((title, index) => {
          const column_width = 100 / titles.length + "%"
          return (
            <th className="schedule-table-header" style={{ width: column_width }} key={index}>
              <p className="stop-name">{title}</p>
            </th>
          )
        })}
      </tr>
    </>
  )
}

export {
  Fares,
  FaresTable
}
